import { globalVariables } from "helper/globalVariables";

export const ReportsList = [
  globalVariables.finalEntryTelly,
  globalVariables.passRate,
  globalVariables.competitorList,
  globalVariables.trialStatistics,
  globalVariables.trialResultsNAE,
  globalVariables.trialPremier,
  globalVariables.dogResults,
  globalVariables.dogResultsPremier,
  globalVariables.getPotentialTitles,
];

export const TrailStatus = [
  globalVariables.approve,
  globalVariables.reject,
  globalVariables.pending,
];
